<ion-header class="modal-header">
  <div class="modal-title">
    <h3 *ngIf="!isCloning">Edit template</h3>
    <h3 *ngIf="isCloning">Create a copy</h3>
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="clear" shape="round" class="close-button" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card style="margin: 15px">
    <ion-card-content>
      <ion-label>
        <strong>Name</strong>
      </ion-label>
      <ion-input #nameInput placeholder="e.g. Weekly Newsletter" [(ngModel)]="name" class="input-field"> </ion-input>
    </ion-card-content>
  </ion-card>
  <ion-card style="margin: 15px" *ngIf="!communityId">
    <ion-list>
      <ion-item>
        <ion-checkbox [(ngModel)]="isDiscoverable"></ion-checkbox>
        <ion-label text-wrap> Others can clone this template </ion-label>
      </ion-item>
    </ion-list>
  </ion-card>
  <div style="text-align: center">
    <ion-button (click)="save()" class="btn-large" [disabled]="isLoading"> Save </ion-button>
    <br />
    <ion-button (click)="delete()" color="danger" fill="clear" *ngIf="!isNew && !isCloning" [disabled]="isLoading">
      Delete
    </ion-button>
  </div>
</ion-content>
